import { Navigate, Outlet } from "react-router-dom";
import { useUserStore } from "../store/userStore";
import { isOwnerRoleId } from "../hooks/useIsReseller";

interface RoleProtectedRouteProps {
  allowedRoles?: string[];
  allowedRoleIds?: string[];
  restrictedRoles?: string[];
  redirectTo?: string;
}

/**
 * Componente que protege rutas basándose en el rol del usuario.
 * Lee del store reactivo (zustand) con fallback a localStorage para bootstrap.
 * Si el usuario tiene un rol restringido, lo redirige a la ruta especificada.
 */
export default function RoleProtectedRoute({
  allowedRoles = [],
  allowedRoleIds = [],
  restrictedRoles = [],
  redirectTo = "/admin/units",
}: RoleProtectedRouteProps) {
  const user = useUserStore((state) => state.user);
  const userRole = user?.role_name ?? localStorage.getItem("userRole");
  const userRoleId = user?.role_id ?? localStorage.getItem("userRoleId");

  // El owner (Propietario) es el rol más alto: pasa todo gate de rol.
  if (isOwnerRoleId(userRoleId)) return <Outlet />;

  // Si hay roles restringidos y el usuario tiene uno de ellos, redirigir
  if (
    restrictedRoles.length > 0 &&
    userRole &&
    restrictedRoles.includes(userRole)
  ) {
    return <Navigate to={redirectTo} replace />;
  }

  // Si hay role IDs permitidos definidos y el usuario no tiene uno de ellos, redirigir
  if (allowedRoleIds.length > 0) {
    if (!userRoleId || !allowedRoleIds.includes(userRoleId)) {
      return <Navigate to={redirectTo} replace />;
    }
  }

  // Si hay roles permitidos definidos y el usuario no tiene uno de ellos, redirigir
  if (allowedRoles.length > 0 && userRole && !allowedRoles.includes(userRole)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
}
